/* hb-deckbrowser.js - Deck Browser: real decklists scored against live stock.
   Data: assets/decks.json (preconstructed products, MTGJSON)
       + assets/decks-meta.json (competitive metagame archetypes)
       + assets/stock.json (our in-stock index). */
(function(){
  var M = document.getElementById('hb-deckbrowser');
  if(!M) return;
  var DECKS_URL = M.getAttribute('data-decks'),
      STOCK_URL = M.getAttribute('data-stock'),
      META_URL  = M.getAttribute('data-meta');
  var D=null, S=null, NAMES=null, SCORED=[], VIEW=[], SEL=null, METAINFO=null;
  var F = { inStockOnly:false, colours:{}, types:{}, sources:{}, q:'', sort:'buildable' };
  /* Deck sources. 'meta' = tournament results (MTGO published decklists + EDHTop16).
     'precon' = official WotC preconstructed products. 'community' = Moxfield /
     Archidekt style user decklists, which need granted API access from those
     sites; when they land they carry d.src='community' and this already handles them. */
  var SRC_LABEL = { meta:'Competitive metagame', precon:'Preconstructed products', community:'Community decklists' };
  var SRC_ORDER = ['meta','precon','community'];
  function srcOf(d){ return d.src || 'precon'; }
  var PAGE = 24, shown = PAGE;

  function norm(s){ s=s||'';
    try{ s=s.normalize('NFD').replace(/[\u0300-\u036f]/g,''); }catch(e){}
    return s.replace(/[\u2018\u2019\u02bc]/g,"'").replace(/[\u2013\u2014]/g,'-')
      .toLowerCase().replace(/\u00e6/g,'ae').replace(/\u0153/g,'oe').replace(/\s+/g,' ').trim(); }
  function front(s){ return String(s||'').split(' // ')[0]; }
  function money(n){ return '$' + (Math.round(n*100)/100).toFixed(2); }
  function esc(s){ var d=document.createElement('div'); d.textContent=s==null?'':String(s); return d.innerHTML; }

  function lookup(name){
    if(!S) return null;
    return S[norm(name)] || S[norm(front(name))] || null;
  }

  function score(d){
    var have=0, miss=0, cost=0, haveList=[], missList=[];
    d.k.forEach(function(p){
      var nm = NAMES[p[0]], qty = p[1], row = lookup(nm);
      if(row){ have += qty; cost += row[1]*qty; haveList.push([nm, qty, row]); }
      else { miss += qty; missList.push([nm, qty]); }
    });
    var tot = have+miss;
    return { d:d, have:have, miss:miss, tot:tot, pct: tot? Math.round(have/tot*100):0, cost:cost, haveList:haveList, missList:missList };
  }

  var PIPS = {W:'#F8F0D8', U:'#B3D5EE', B:'#3B3230', R:'#EFA08A', G:'#98C795', C:'#C9C4BE'};
  function pipsHTML(ci){
    var arr = (ci && ci.length) ? ci : ['C'];
    return arr.map(function(c){ return '<span class="hbdb-pip" style="background:'+(PIPS[c]||PIPS.C)+'" title="'+c+'"></span>'; }).join('');
  }
  function artURL(name){
    return 'https://api.scryfall.com/cards/named?exact=' + encodeURIComponent(name) + '&format=image&version=small';
  }

  function tagsFor(s){
    var t=[];
    if(srcOf(s.d)==='meta'){
      if(s.d.share!=null) t.push(s.d.share+'% of the '+s.d.fmt+' meta');
      if(s.d.seen) t.push(s.d.seen+' recent finishes');
    } else if(s.d.cr>=40){ t.push('Creature-heavy'); }
    if(s.d.mv) t.push('avg MV ' + s.d.mv);
    return t;
  }

  function applyFilters(){
    var cols = Object.keys(F.colours).filter(function(k){return F.colours[k];});
    var typs = Object.keys(F.types).filter(function(k){return F.types[k];});
    var srcs2 = Object.keys(F.sources).filter(function(k){return F.sources[k];});
    var q = norm(F.q);
    VIEW = SCORED.filter(function(s){
      if(F.inStockOnly && s.have===0) return false;
      if(typs.length && typs.indexOf(s.d.t)<0) return false;
      if(srcs2.length && srcs2.indexOf(srcOf(s.d))<0) return false;
      if(cols.length){
        var ci = s.d.ci.length? s.d.ci : ['C'];
        var ok = cols.every(function(c){ return ci.indexOf(c)>-1; });
        if(!ok) return false;
      }
      if(q && norm(s.d.n).indexOf(q)<0 && norm(s.d.c).indexOf(q)<0) return false;
      return true;
    });
    if(F.sort==='buildable') VIEW.sort(function(a,b){ return b.pct-a.pct || b.have-a.have; });
    else if(F.sort==='meta') VIEW.sort(function(a,b){
      var x = (srcOf(a.d)==='meta' && a.d.share!=null)? a.d.share : -1;
      var y = (srcOf(b.d)==='meta' && b.d.share!=null)? b.d.share : -1;
      return y-x || b.pct-a.pct; });
    else if(F.sort==='az') VIEW.sort(function(a,b){ return a.d.n.localeCompare(b.d.n); });
    else if(F.sort==='largest') VIEW.sort(function(a,b){ return b.tot-a.tot; });
    shown = PAGE;
    render();
  }

  function deckCard(s, i){
    var first = s.haveList.length? s.haveList[0][0] : NAMES[s.d.k[0][0]];
    var cls = s.pct>=100?'is-full':(s.pct>=60?'is-most':(s.pct>0?'is-some':'is-none'));
    var meta = srcOf(s.d)==='meta';
    return '<article class="hbdb-card '+cls+(meta?' is-meta':'')+'" data-i="'+i+'" tabindex="0">'
      + '<div class="hbdb-card__art"><img loading="lazy" alt="" src="'+artURL(first)+'">'
      +   (meta? '<span class="hbdb-badge">Tournament</span>' : '')
      + '</div>'
      + '<div class="hbdb-card__body">'
      +   '<div class="hbdb-card__top"><h3>'+esc(s.d.n)+'</h3><span class="hbdb-pct">'+s.pct+'%</span></div>'
      +   '<div class="hbdb-row">'+pipsHTML(s.d.ci)+'<span class="hbdb-type">'+esc(s.d.t)+'</span></div>'
      +   '<div class="hbdb-tags">'+tagsFor(s).map(function(t){return '<span class="hbdb-tag">'+esc(t)+'</span>';}).join('')+'</div>'
      +   '<div class="hbdb-bar"><i style="width:'+s.pct+'%"></i></div>'
      +   '<p class="hbdb-stat"><b>'+s.pct+'% buildable</b> \u2014 '+s.have+'/'+s.tot+' in stock</p>'
      +   (s.have? '<p class="hbdb-cost"><b>'+money(s.cost)+'</b> to build in stock</p>' : '<p class="hbdb-cost hbdb-cost--none">nothing in stock yet</p>')
      + '</div></article>';
  }

  function render(){
    var grid = M.querySelector('.hbdb-grid');
    var count = M.querySelector('.hbdb-count');
    count.innerHTML = 'Showing <b>'+Math.min(shown,VIEW.length)+'</b> of '+VIEW.length+' decks'
      + (F.sort==='buildable'? ' \u2014 most buildable first':'')
      + (F.sort==='meta'? ' \u2014 biggest share of the metagame first':'');
    if(!VIEW.length){ grid.innerHTML = '<p class="hbdb-empty">No decks match those filters. Try clearing a colour or format.</p>'; M.querySelector('.hbdb-more').hidden=true; return; }
    grid.innerHTML = VIEW.slice(0,shown).map(deckCard).join('');
    M.querySelector('.hbdb-more').hidden = shown>=VIEW.length;
  }

  function provHTML(d){
    var cedh = d.fmt==='cEDH';
    var srcName = cedh? 'EDHTop16' : 'MTGO published decklists';
    var srcHome = cedh? 'https://edhtop16.com/' : 'https://www.mtgo.com/decklists';
    var rows=[];
    if(d.share!=null && d.pool) rows.push(['Metagame share', '<b>'+d.share+'%</b> of '+esc(d.fmt)+' \u2014 '+d.seen+' of '+d.pool+' tournament decks']);
    if(d.tn) rows.push(['Event', esc(d.tn) + (d.d? ' \u00b7 '+esc(d.d) : '')]);
    var who=[];
    if(d.st) who.push('finished '+esc(d.st));
    if(d.pl) who.push(d.pu? '<a href="'+esc(d.pu)+'" target="_blank" rel="noopener">'+esc(d.pl)+'</a>' : esc(d.pl));
    if(who.length) rows.push(['Sample list', who.join(' \u00b7 ')]);
    return '<div class="hbdb-prov">'
      + '<h4 class="hbdb-lh">Where this list comes from</h4>'
      + rows.map(function(r){ return '<p><span>'+r[0]+'</span>'+r[1]+'</p>'; }).join('')
      + '<p class="hbdb-prov__src">Source: <a href="'+srcHome+'" target="_blank" rel="noopener">'+srcName+'</a>'
      + (d.url? ' \u00b7 <a href="'+esc(d.url)+'" target="_blank" rel="noopener">view the original decklist</a>' : '')
      + (METAINFO && METAINFO.window? '<br><i>'+esc(METAINFO.window)+'</i>' : '')
      + '</p></div>';
  }

  function openDeck(i){
    SEL = VIEW[i]; if(!SEL) return;
    var s=SEL;
    var body = '<div class="hbdb-modal__head"><div><h2>'+esc(s.d.n)+'</h2>'
      + '<p class="hbdb-modal__sub">'+pipsHTML(s.d.ci)+' <span>'+esc(s.d.t)+'</span> <span>'+esc(s.d.c)+'</span> <span>'+s.tot+' cards</span></p></div>'
      + '<button class="hbdb-close" aria-label="Close">&times;</button></div>'
      + '<div class="hbdb-modal__stat"><div class="hbdb-bar"><i style="width:'+s.pct+'%"></i></div>'
      + '<p><b>'+s.pct+'% buildable</b> \u2014 '+s.have+' of '+s.tot+' cards in stock'
      + (s.have? ' \u00b7 <b>'+money(s.cost)+'</b> for what we have':'')+'</p></div>';
    if(srcOf(s.d)==='meta') body += provHTML(s.d);
    if(s.haveList.length){
      body += '<h4 class="hbdb-lh">In stock here ('+s.haveList.length+')</h4><ul class="hbdb-list">'
        + s.haveList.map(function(r){ return '<li><span class="hbdb-q">'+r[1]+'\u00d7</span><a href="/products/'+r[2][2]+'">'+esc(r[0])+'</a><span class="hbdb-p">'+money(r[2][1]*r[1])+'</span></li>'; }).join('')
        + '</ul>';
    }
    if(s.missList.length){
      body += '<h4 class="hbdb-lh hbdb-lh--miss">Not in stock ('+s.missList.length+')</h4><ul class="hbdb-list hbdb-list--miss">'
        + s.missList.map(function(r){ return '<li><span class="hbdb-q">'+r[1]+'\u00d7</span><span>'+esc(r[0])+'</span></li>'; }).join('')
        + '</ul>';
    }
    body += '<div class="hbdb-modal__foot">'
      + (s.haveList.length? '<button class="hbdb-addall button">Add '+s.haveList.length+' in-stock cards to cart</button>' : '')
      + '<span class="hbdb-addmsg"></span></div>';
    var mo = M.querySelector('.hbdb-modal');
    mo.querySelector('.hbdb-modal__inner').innerHTML = body;
    mo.hidden = false;
    document.body.style.overflow='hidden';
  }
  function closeDeck(){ M.querySelector('.hbdb-modal').hidden=true; document.body.style.overflow=''; SEL=null; }

  async function addAll(btn){
    if(!SEL) return;
    var msg = M.querySelector('.hbdb-addmsg');
    btn.disabled=true; msg.textContent='Looking up '+SEL.haveList.length+' cards\u2026';
    var items=[], failed=0, done=0;
    var list = SEL.haveList.slice();
    async function one(r){
      try{
        var res = await fetch('/products/'+r[2][2]+'.js');
        if(!res.ok){ failed++; return; }
        var p = await res.json();
        var v = (p.variants||[]).filter(function(x){ return x.available; })[0];
        if(v) items.push({id:v.id, quantity:r[1]}); else failed++;
      }catch(e){ failed++; }
      done++; msg.textContent='Looking up '+done+'/'+list.length+'\u2026';
    }
    for(var i=0;i<list.length;i+=8){ await Promise.all(list.slice(i,i+8).map(one)); }
    if(!items.length){ msg.textContent='Could not add these right now.'; btn.disabled=false; return; }
    try{
      var add = await fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:items})});
      if(!add.ok) throw new Error('cart');
      msg.textContent = 'Added '+items.length+' cards' + (failed? ' ('+failed+' unavailable)':'') + '.';
      document.dispatchEvent(new CustomEvent('hb:cart-updated'));
      setTimeout(function(){ window.location='/cart'; }, 900);
    }catch(e){ msg.textContent='Cart error \u2014 please try again.'; btn.disabled=false; }
  }

  function buildFacets(){
    var types={}, cols={W:0,U:0,B:0,R:0,G:0,C:0};
    SCORED.forEach(function(s){ types[s.d.t]=(types[s.d.t]||0)+1;
      (s.d.ci.length?s.d.ci:['C']).forEach(function(c){ if(cols[c]!==undefined) cols[c]++; }); });
    M.querySelector('.hbdb-colours').innerHTML = Object.keys(cols).map(function(c){
      return '<button class="hbdb-col" data-c="'+c+'" title="'+c+'" style="background:'+PIPS[c]+'"><span>'+c+'</span></button>'; }).join('');
    var srcs={};
    SCORED.forEach(function(s){ var k=srcOf(s.d); srcs[k]=(srcs[k]||0)+1; });
    var keys = SRC_ORDER.filter(function(k){ return srcs[k] || k==='community'; });
    Object.keys(srcs).forEach(function(k){ if(keys.indexOf(k)<0) keys.push(k); });
    var srcEl=M.querySelector('.hbdb-sources');
    if(srcEl) srcEl.innerHTML = keys.map(function(k){
      var n=srcs[k]||0, off=n===0;
      return '<label class="hbdb-check'+(off?' is-off':'')+'"><input type="checkbox" data-src="'+k+'"'+(off?' disabled':'')+'><span>'+(SRC_LABEL[k]||k)+'</span><i>'+n+'</i></label>';
    }).join('');
    M.querySelector('.hbdb-types').innerHTML = Object.keys(types).sort(function(a,b){return types[b]-types[a];}).map(function(t){
      return '<label class="hbdb-check"><input type="checkbox" data-t="'+esc(t)+'"><span>'+esc(t)+'</span><i>'+types[t]+'</i></label>'; }).join('');
    var note = M.querySelector('.hbdb-updated');
    if(note && METAINFO && METAINFO.generated){
      note.textContent = 'Metagame data updated ' + METAINFO.generated.slice(0,10) + '.';
    }
  }

  function wire(){
    M.addEventListener('click', function(e){
      var card=e.target.closest('.hbdb-card'); if(card){ openDeck(+card.getAttribute('data-i')); return; }
      if(e.target.closest('.hbdb-close')){ closeDeck(); return; }
      if(e.target.classList.contains('hbdb-modal')){ closeDeck(); return; }
      var aa=e.target.closest('.hbdb-addall'); if(aa){ addAll(aa); return; }
      var col=e.target.closest('.hbdb-col');
      if(col){ var c=col.getAttribute('data-c'); F.colours[c]=!F.colours[c]; col.classList.toggle('is-on', F.colours[c]); applyFilters(); return; }
      if(e.target.closest('.hbdb-more')){ shown+=PAGE; render(); return; }
      var sb=e.target.closest('.hbdb-sort button');
      if(sb){ F.sort=sb.getAttribute('data-s');
        M.querySelectorAll('.hbdb-sort button').forEach(function(b){ b.classList.toggle('is-on', b===sb); });
        applyFilters(); return; }
    });
    M.addEventListener('keydown', function(e){ if(e.key==='Enter' && e.target.classList.contains('hbdb-card')) openDeck(+e.target.getAttribute('data-i')); if(e.key==='Escape') closeDeck(); });
    M.addEventListener('change', function(e){
      if(e.target.matches('[data-t]')){ F.types[e.target.getAttribute('data-t')]=e.target.checked; applyFilters(); }
      if(e.target.matches('[data-src]')){ F.sources[e.target.getAttribute('data-src')]=e.target.checked; applyFilters(); }
      if(e.target.matches('.hbdb-instock')){ F.inStockOnly=e.target.checked; applyFilters(); }
    });
    var t=null;
    M.querySelector('.hbdb-search').addEventListener('input', function(e){
      clearTimeout(t); var v=e.target.value; t=setTimeout(function(){ F.q=v; applyFilters(); }, 180);
    });
  }

  function getJSON(u){ return fetch(u).then(function(r){ if(!r.ok) throw new Error('http '+r.status); return r.json(); }); }

  async function init(){
    try{
      var res = await Promise.all([getJSON(DECKS_URL), getJSON(STOCK_URL)]);
      D=res[0]; NAMES=D.names.slice(); S=res[1].idx || res[1];
      var decks = D.decks.slice();
      if(META_URL){
        try{
          var mt = await getJSON(META_URL);
          var off = NAMES.length;
          NAMES = NAMES.concat(mt.names||[]);
          METAINFO = { generated:mt.generated, source:mt.source, window:mt.window };
          (mt.decks||[]).forEach(function(d){
            d.k = d.k.map(function(p){ return [p[0]+off, p[1]]; });
            if(!d.src) d.src='meta';
            decks.push(d);
          });
        }catch(e){ /* metagame feed optional - precons still work */ }
      }
      SCORED = decks.map(score);
      M.querySelector('.hbdb-loading').hidden=true;
      M.querySelector('.hbdb-main').hidden=false;
      buildFacets(); wire(); applyFilters();
    }catch(e){
      M.querySelector('.hbdb-loading').innerHTML = '<p>Could not load the deck list just now. Please refresh.</p>';
    }
  }
  init();
})();
